const styles = theme => ({
    grow: {
        flexGrow: 1,
    },
    spacer: {
        padding: "8px",
    },
    blockContainer: {
        backgroundColor: theme.palette.background.elevated,
        minHeight: "250px",
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(6),
        color: theme.palette.text.primary
    },
    cardHeader: {
        cursor: "pointer",
        color: theme.palette.text.primary
    },
});

export default styles;
